module.exports = __webpack_public_path__ + "static/media/maquina.f087732c.svg";